import { render, staticRenderFns } from "./VerifiedPurchase.vue?vue&type=template&id=ec6260f8"
import script from "./VerifiedPurchase.vue?vue&type=script&lang=js"
export * from "./VerifiedPurchase.vue?vue&type=script&lang=js"
import style0 from "./VerifiedPurchase.vue?vue&type=style&index=0&id=ec6260f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports